import { getDefaultHeaders } from "./utils";

export async function addCharacterInfo(comicInputFileId, character) {
  try {
    const headers_get = await getDefaultHeaders();
    const headers_put = await getDefaultHeaders(true, true);
    
    // First, fetch the current character information
    const getUrl = `/api/character-info/${comicInputFileId}/`;
    const getResponse = await fetch(getUrl, {
      method: "GET",
      headers: headers_get
    });
    
    if (!getResponse.ok) {
      throw new Error(`Failed to get character info: ${getResponse.status}`);
    }
    
    // Parse the current character data
    const currentData = await getResponse.json();
    
    // Add the new character to the existing list
    const updatedData = {
      ...currentData,
      characters: [...(currentData.characters || []), character]
    };
    
    // Update the character information
    const updateUrl = `/api/character-info/${comicInputFileId}/`;
    const updateResponse = await fetch(updateUrl, {
      method: "PUT",
      headers: headers_put,
      body: JSON.stringify(updatedData)
    });
    
    if (!updateResponse.ok) {
      const errorData = await updateResponse.json().catch(() => null);
      throw new Error(errorData?.error || `HTTP error ${updateResponse.status}`);
    }
    
    return await updateResponse.json();
  } catch (err) {
    console.error("Error adding character information:", err);
    throw err;
  }
}
